import { useTranslate } from '@/hooks/useTranslate';

export const Seprator = () => {
  const { t } = useTranslate();
  return (
    <div className="flex items-center justify-center w-full gap-2">
      <div className="flex-grow border-t border-base-border"></div>
      <div className="text-muted-foreground text-sm font-normal whitespace-nowrap">{t('orPayAnotherWay')}</div>
      <div className="flex-grow border-t border-base-border" />
    </div>
  );
};
